/**
 * BTB Hub delivery estimate — DOM wiring.
 *
 * Reads the JSON data island emitted by snippets/btb-delivery-estimate.liquid,
 * asks assets/btb-delivery-engine.js for the date, and writes it in.
 *
 * The data island is the ONLY interface to Liquid — this file never scrapes
 * product data out of the surrounding markup, so theme markup changes cannot
 * silently break it.
 *
 * Variant reactivity (Task 5) rides Dawn's pub/sub, matching the pattern in
 * assets/variant-image-filter.js.
 */
(function () {
  'use strict';

  function parseData(container) {
    var el = container.querySelector('[data-btb-delivery-data]');
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      // A malformed island must not take the page down; the block simply
      // stays in its pre-JS state (subline only, no date).
      return null;
    }
  }

  function renderDeliveryState(container, data, variantId) {
    var availableEl = container.querySelector('[data-btb-delivery-available]');
    var unavailableEl = container.querySelector('[data-btb-delivery-unavailable]');
    var dateEl = container.querySelector('[data-btb-delivery-date]');
    var mailtoEl = container.querySelector('[data-btb-delivery-mailto]');
    var termsEl = container.querySelector('[data-btb-delivery-terms]');
    if (!availableEl || !unavailableEl || !dateEl) { return; }

    var info = data.variants[String(variantId)];
    var isAvailable = info ? info.available : false;

    // SKU is variant-level, so the enquiry subject has to follow the picker.
    //
    // Deliberately does NOT skip the update when the SKU is blank. Guarding on
    // info.sku left the href pointing at the PREVIOUS variant, so the card could
    // show the out-of-stock line for variant B while the enquiry email named
    // variant A — a misattributed trade enquiry, with nothing to reveal it at
    // either end. An empty subject is a much cheaper failure than a wrong one.
    if (mailtoEl && info) {
      mailtoEl.setAttribute(
        'href',
        'mailto:sales@btbhub.co.uk?subject=' +
          encodeURIComponent('Lead time enquiry - ' + (info.sku || ''))
      );
    }

    if (isAvailable) {
      var date = window.BTBDeliveryEngine.computeDeliveryDate({
        nowUtc: new Date(),
        cutoffHour: data.cutoffHour,
        leadDays: data.leadDays
      });
      dateEl.textContent = window.BTBDeliveryEngine.formatDeliveryDate(date);
      availableEl.removeAttribute('hidden');
      unavailableEl.setAttribute('hidden', '');
      // The lead-time subline belongs to the available state only — see the
      // comment on [data-btb-delivery-terms] in the snippet.
      if (termsEl) { termsEl.removeAttribute('hidden'); }
    } else {
      availableEl.setAttribute('hidden', '');
      unavailableEl.removeAttribute('hidden');
      if (termsEl) { termsEl.setAttribute('hidden', ''); }
    }
  }

  function init() {
    if (!window.BTBDeliveryEngine) { return; }

    var containers = document.querySelectorAll('[data-btb-delivery]');
    Array.prototype.forEach.call(containers, function (container) {
      var data = parseData(container);
      if (!data) { return; }

      // Deep links carry ?variant=<id>; fall back to the Liquid-rendered
      // initial variant.
      var params = new URLSearchParams(window.location.search);
      var urlVariant = params.get('variant');
      var variantId = (urlVariant && data.variants[urlVariant]) ? urlVariant : data.initialVariantId;

      container.__btbDeliveryData = data;
      renderDeliveryState(container, data, variantId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify partially re-renders the section when a merchant edits a section or
  // block setting in the theme editor. The replacement DOM is a fresh clone with
  // no __btbDeliveryData expando, and init() had already run, so without this the
  // card loses its heading and date and shows only the subline until a full
  // reload — which is exactly what happens the first time anyone drags this block
  // in or nudges its cutoff. Three settings are the block's whole reason for
  // existing, so the editor is the one place it must not break.
  //
  // init() re-reads the island and re-attaches the expando from scratch, so it is
  // idempotent and needs no guard. Same convention as assets/theme-editor.js:28.
  document.addEventListener('shopify:section:load', init);

  // Only availability and SKU change per variant — the lead time is
  // product-level and never recalculates. Guard the globals the same way
  // assets/variant-image-filter.js:29 does, so the block degrades to its
  // initial render if the theme's pub/sub is ever absent.
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.variant) { return; }
      var variant = event.data.variant;

      var containers = document.querySelectorAll('[data-btb-delivery]');
      Array.prototype.forEach.call(containers, function (container) {
        var data = container.__btbDeliveryData;
        if (!data) { return; }

        // Prefer the event's own variant — it is authoritative and may carry a
        // variant the island did not (e.g. after a section re-render). Fall
        // back to the island map.
        if (!data.variants[String(variant.id)]) {
          data.variants[String(variant.id)] = {
            available: variant.available,
            sku: variant.sku || ''
          };
        } else {
          data.variants[String(variant.id)].available = variant.available;
        }

        renderDeliveryState(container, data, variant.id);
      });
    });
  }

  // Exposed so the variant subscription in this file (Task 5) and any future
  // caller share one code path.
  window.BTBDeliveryEstimate = { render: renderDeliveryState };
})();
